import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import DrawerSimple from "ds/components/DrawerNew/Simple";

import RoleInfoDrawerContent from "./Content";

const RoleInfoDrawer = createDrawer(() => {
  return (
    <DrawerSimple>
      <RoleInfoDrawerContent />
    </DrawerSimple>
  );
});

export const showRoleInfoDrawer = createDrawerTrigger(RoleInfoDrawer);
